export interface CandidateItem {
  id: string;
  name: string;
  score: number;
  email: string;
  phone_number: string;
  created_at: string;
  portfolio: string;
  resume: string;
  bucket?: string;
}

export interface CandidatesComparisonState {
  primaryCandidateId: string | null;
  comparisonCandidateIds: string[];
  candidates: CandidateItem[];
}

export const SET_CC_CANDIDATES = "SET_CC_CANDIDATES";
export const SET_CC_PRIMARY = "SET_CC_PRIMARY";
export const TOGGLE_CC_COMPARISON = "TOGGLE_CC_COMPARISON";
export const RESET_CC = "RESET_CC";

interface SetCandidatesAction {
  type: typeof SET_CC_CANDIDATES;
  payload: CandidateItem[];
}

interface SetPrimaryAction {
  type: typeof SET_CC_PRIMARY;
  payload: string;
}

interface ToggleComparisonAction {
  type: typeof TOGGLE_CC_COMPARISON;
  payload: string;
}

interface ResetAction {
  type: typeof RESET_CC;
}

export type CandidatesComparisonActions =
  | SetCandidatesAction
  | SetPrimaryAction
  | ToggleComparisonAction
  | ResetAction;